import './styles/integration-steps.scss'

import React      from 'react'
import PropTypes  from 'prop-types'

import ReRoutingStepConfigRenderer from './configRenderers/ReRoutingStepConfigRenderer'

const configRenderers = {
  'ReRoutingStepConfig': ReRoutingStepConfigRenderer,
}

function getConfigRenderer(step) {
  const renderer = step.config
    && step.config.__typename
    && configRenderers[step.config.__typename]
  
  return renderer
    ? React.createElement(renderer, { step })
    : null
}

export default class IntegrationSteps extends React.Component {
  static propTypes = {
    steps: PropTypes.array,
  }

  render() {
    const { steps } = this.props

    if (!steps || steps.length === 0) return null

    return (
      <div className="integration-steps">
        {
          steps.map((step, index) => {
            const configRenderer = getConfigRenderer(step)

            return (
              <div key={index} className="integration-step">
                <label>Integration Type:</label>              
                { step.type }

                {
                  configRenderer && (
                    <div className="config-renderer-section">
                      { configRenderer }
                    </div>
                  )
                }
              </div>
            )
          })
        }
      </div>
    )
  }
}